import { Layout } from "antd";

import { PropsWithChildren } from "react";
import FooterComponent from "./components/FooterComponent";
import HeaderComponent from "./components/HeaderComponent";
import styles from "./style.module.scss";

const { Header, Content } = Layout;

type DefaultLayoutType = PropsWithChildren & {
  navType: any;
};

const DefaultLayout: React.FC<DefaultLayoutType> = ({ navType, children }) => {
  return (
    <div className={styles.main}>
      <Layout className={styles.layout}>
        <Header className={`${styles.headerContainer}`}>
          <HeaderComponent />
        </Header>
        <Layout
          className={`${styles.layout} ${styles.content}`}
          id="body-container"
        >
          <Content className={styles.contentContainer}>
            <div className={styles.container} id="containerElement">
              <div className={styles.pageContainer}>{children}</div>
            </div>
            <FooterComponent />
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default DefaultLayout;
